import { Component } from '@angular/core';

@Component({
  selector: 'app-subscription-banner-paid',
  templateUrl: './subscription-banner-paid.component.html',
  styleUrls: ['./subscription-banner-paid.component.scss'],
  standalone: false
})
export class SubscriptionBannerPaidComponent {
}
